import { useNavigate } from "react-router";

const history = {
  navigate: null,
  push: (page, ...rest) => history.navigate(page, ...rest),
  back: () => history.navigate(-1),
};

export const HistoryConfigurator = () => {
  history.navigate = useNavigate();

  return null;
};

export default history;
